var $10f3d0968857aa9f$exports = {};
$10f3d0968857aa9f$exports = {
    "info": `Info`,
    "negative": `Error`,
    "positive": `Success`
};


export {$10f3d0968857aa9f$exports as default};
//# sourceMappingURL=en-US.mjs.map
